(() => {
  const name = 'orderModel';

  App.cartPage = App.cartPage || {};
  const orderModelModule = App.cartPage[name] || {};

  App.cartPage[name] = (() => {
    const isCartPage = App.currentPage === 'cartPage';
    let productTypeCount = {};

    const genRandomString = (charCount) => {
      // Don't use zero in 'chars'. BE truncates zero if cart item's hash starts with zero.
      const chars = '123456789';
      let randomstring = '';
      for (let i = 0; i < charCount; i += 1) {
        const rnum = Math.floor(Math.random() * 10);
        randomstring += chars.substring(rnum, rnum + 1);
      }
      return randomstring;
    };

    /**
     * Constructor for all products on cart page
     * @param {Object} conf - parameters for the product
     * @constructor
     */
    const OrderItem = function (conf) {
      $.extend(this, conf);
    };

    OrderItem.prototype = new App.product.CurrentProduct();

    OrderItem.prototype.customAddToCartJson = function customAddToCartJsonOrderItem() {
      const tempJson = {};
      tempJson.productID = this.productID;
      tempJson.groupID = this.groupID;
      tempJson.size = this.size;
      tempJson.type = this.type;
      tempJson.name = this.name;
      if (this.selectedArticle && this.selectedArticle.powers) {
        tempJson.power = this.selectedArticle.powers;
        if (this.isReadingGlasses === true) {
          tempJson.isReadingGlasses = true;
        }
      }

      this.getQuantity(tempJson);

      return tempJson;
    };

    OrderItem.prototype.getQuantity = function getQuantityOrderItem(obj) {
      // eslint-disable-next-line no-param-reassign
      obj.quantity = this.quantity;
    };

    OrderItem.prototype.highlight = function highlightOrderItem(highlight) {
      this.element.toggleClass('product-list__item__border-red', highlight);
    };

    OrderItem.prototype.expandPrescriptions = function expandPrescriptionsOrderItem() {
      const $checkoutChangeBtn = this.element.find('.js-checkout-change-btn');
      if (!$checkoutChangeBtn.hasClass('expanded')) {
        $checkoutChangeBtn.trigger('click');
      }
    };

    const jsonForInStock = function () {
      const params = !this.selectedArticle ? {} : {
        prod_pow: this.selectedArticle.powers,
        prod_bc: this.selectedArticle.baseCurves,
        prod_dia: this.selectedArticle.diameters,
        prod_cyl: this.selectedArticle.cylinders,
        prod_axis: this.selectedArticle.axis,
        prod_color: this.selectedArticle.colors,
        prod_add: this.selectedArticle.extraPowers,
      };
      return {
        id: this.productID,
        size: this.size,
        type: this.type,
        lensData: params,
      };
    };

    const orderItemLens = (conf) => {
      /* eslint-disable no-param-reassign */
      conf.isLens = true;
      conf.jsonForInStock = jsonForInStock;
      conf.element = $(JST['quick-cart-order-row-lenses'](conf));

      if (conf.replacements && isCartPage) {
        conf.element
          .find('.product-list__item--replacement')
          .append($(JST['cart-page-replacement'](conf)));
      }
      conf.getQuantity = function getQuantityOrderItemLens(obj) {
        const temp = {
          eye: '',
          quantity: this.quantity,
          params: App.product.indexArrayFor(this.articles, this.selectedArticle, App.product.paramsNamesCartPage),
        };
        obj['lenses[]'] = JSON.stringify(temp);
      };
      return new OrderItem(conf);
      /* eslint-enable no-param-reassign */
    };

    const compareFramesAddons = (a, b) => {
      const productTypeOrder = ['PROGRESSIVE_GLASS_TYPE', 'GLASSINDEX', 'GLASS', 'EXTRA'];
      return productTypeOrder.indexOf(a.customProductType) - productTypeOrder.indexOf(b.customProductType);
    };

    const includeProgressiveGlassType = (product) => {
      const { displayName, productType } = product;

      // Add "customProductType" field to differentiate "Progressive Glass Type" from other products.
      // eslint-disable-next-line no-param-reassign
      product.customProductType = productType;
      if (typeof displayName === 'string' && displayName.toLowerCase().indexOf('progressive type') > -1) {
        // eslint-disable-next-line no-param-reassign
        product.customProductType = productType === 'GLASS' ? 'PROGRESSIVE_GLASS_TYPE' : productType;
      }
      return true;
    };

    const orderItemGlass = (conf) => {
      // eslint-disable-next-line no-param-reassign
      conf.element = $(JST['quick-cart-order-row-frames'](conf));
      return new OrderItem(conf);
    };

    const orderItemExtras = (conf) => {
      // eslint-disable-next-line no-param-reassign
      conf.element = $(JST['quick-cart-order-row'](conf));
      return new OrderItem(conf);
    };

    const orderItemSunglasses = (conf) => {
      // eslint-disable-next-line no-param-reassign
      conf.jsonForInStock = jsonForInStock;
      // eslint-disable-next-line no-param-reassign
      conf.element = $(JST['quick-cart-order-row'](conf));
      return new OrderItem(conf);
    };

    /**
     * Used to see which number in the cart this is of the product type. Some logic is only
     * going to be used for the first LENS in the cart for instance, but not the rest.
     * @param item
     */
    const setProductTypeCount = (item) => {
      if (!productTypeCount) {
        productTypeCount = {};
      }
      if (!productTypeCount[item.type]) {
        productTypeCount[item.type] = 1;
      } else {
        productTypeCount[item.type] += productTypeCount[item.type];
      }
      // eslint-disable-next-line no-param-reassign
      item.productTypeCount = productTypeCount[item.type];
    };

    // eslint-disable-next-line consistent-return
    const createOrderItem = (item = {}) => {
      // eslint-disable-next-line no-param-reassign
      item.voucher = window.dataLayer.cartData && window.dataLayer.cartData.voucher;
      setProductTypeCount(item);
      switch (item.type) {
        case 'LENS':
          return orderItemLens(item);
        case 'SUNWEAR':
          return orderItemSunglasses(item);
        case 'EXTRA':
          return orderItemExtras(item);
        case 'FRAME':
          return orderItemGlass(item);
        case 'OTHER':
          break;
        default:
      }
    };

    const init = () => {};

    return {
      init,
      createQuickCartItem: createOrderItem,
      generateOrderId: genRandomString,
      compareFramesAddons,
      includeProgressiveGlassType,
      ...orderModelModule,
    };
  })();
})();
